import { getEnergyEfficiencyCertificateOptions } from '@modules/energy-efficiency-certificate/application/get-energy-efficiency-certificate-options'
import { sendDatadogError } from '@ui/plugins/datadog'

export default {
  namespaced: true,
  state: () => ({
    options: [],
    loading: false,
    error: false,
    loaded: false,
  }),
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_OPTIONS(state, options) {
      state.options = options
      state.error = false
      state.loaded = true
    },
    SET_ERROR(state) {
      state.options = []
      state.error = true
      state.loaded = false
    },
  },
  actions: {
    async requestOptions({ commit }) {
      commit('SET_LOADING', true)
      await getEnergyEfficiencyCertificateOptions().execute({
        onOptions: (options) => commit('SET_OPTIONS', options),
        onNetworkError: (error) => {
          sendDatadogError({
            name: 'energy-efficiency-certificate-options-error',
            options: { error },
          })
          commit('SET_ERROR')
        },
      })
      commit('SET_LOADING', false)
    },
  },
}
